<template>
  <div class="avoid-page-break">
      <TestRow class="avoid-page-break" id="64" :profileTest="profileTest" name="Working Memory"/>
  </div>
    
  
  
</template>

<script>
import ProfileTest from "@/js/shared/classes/ProfileTest/SwayProfileTest";
import TestRow from "./TestRow";

export default {
  props: {
    profileTest: ProfileTest
  },
  name: "MemoryTest",
  components: {
    TestRow
  },
  
  
}
</script>

<style scoped>


</style>